import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '画面構成',

  // model
  screenConfigMstModel: [],
  deviceModel: [],
  serviceTypeModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {screenConfigMstParams, deviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'screenConfigMst',
          'device',
          'const'
        ],
        [
          'v1ScreenConfigMstListGet',
          'v1DeviceListGet',
          'v1ServiceTypeListGet'
        ],
        [
          screenConfigMstParams,
          deviceParams,
          {}
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setScreenConfigMstModel', res[0].data.screenConfigMsts)
            commit('setDeviceModel', res[1].data.deviceTypes)
            commit('setServiceTypeModel', res[2].data.serviceTypes)
            console.log('screenConfigMstModel', state.screenConfigMstModel)
            console.log('deviceModel', state.deviceModel)
            console.log('serviceTypeModel', state.serviceTypeModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.ScreenConfigMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setScreenConfigMstModel (state, data) {
    Vue.set(state, 'screenConfigMstModel', data)
  },
  setDeviceModel (state, data) {
    Vue.set(state, 'deviceModel', data)
  },
  setServiceTypeModel (state, data) {
    Vue.set(state, 'serviceTypeModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpScreenConfigName', null)
    Vue.set(state.values, 'inpDeviceType', '')
    Vue.set(state.values, 'inpServiceType', '')
    // Vue.set(state.values, 'inpOrientationKbn', '')
    Vue.set(state.values, 'inpStatus', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpScreenConfigName', data.screenConfigName)
    Vue.set(state.values, 'inpDeviceType', data.deviceTypeUuid)
    Vue.set(state.values, 'inpServiceType', data.serviceTypeKbn)
    // Vue.set(state.values, 'inpOrientationKbn', data.screenOrientationKbn)
    Vue.set(state.values, 'inpStatus', data.screenConfigStatus)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
